// extracted by mini-css-extract-plugin
module.exports = {"spinner_container":"loading_spinner_container__wGHod","spinner_item":"loading_spinner_item__tZ2gU","spinner-spin":"loading_spinner-spin__2y5oa"};